import { render, staticRenderFns } from "./pathogenesis_analysis.vue?vue&type=template&id=10f43e23&scoped=true"
import script from "./pathogenesis_analysis.vue?vue&type=script&lang=js"
export * from "./pathogenesis_analysis.vue?vue&type=script&lang=js"
import style0 from "./pathogenesis_analysis.vue?vue&type=style&index=0&id=10f43e23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f43e23",
  null
  
)

export default component.exports